import Suggestions from "../../components/Suggestions/Suggestions";

const Main: React.FC = () => {
  return <Suggestions />;
};

export default Main;
